module.exports = __webpack_public_path__ + "d65bba267774cccfe317549bfbf71ad7.png";